export enum actionTypes {
    SET_RESIZE_DATA = 'SET_RESIZE_DATA',
    SET_IS_SHOW_TAG = 'SET_IS_SHOW_TAG',
    SET_SHOW_MOBILE_MENU = 'SET_SHOW_MOBILE_MENU',
    SET_SHOW_ACCOUNT_MENU = 'SET_SHOW_ACCOUNT_MENU',
    SET_ACTIVE_TAG_CONFIG = 'SET_ACTIVE_TAG_CONFIG',
    SET_IS_FEATURED_BANNER = 'SET_IS_FEATURED_BANNER',
    SET_IS_SHOW_LOCAL_POPUP = 'SET_IS_SHOW_LOCAL_POPUP',
    SET_IS_DOWNLOAD_APP_OPEN = 'SET_IS_DOWNLOAD_APP_OPEN',
    REMOVE_ACTIVE_TAG_CONFIG = 'REMOVE_ACTIVE_TAG_CONFIG',
    SET_POSITION_STICKY_BUTTON = 'SET_POSITION_STICKY_BUTTON',
    SET_IS_SHOW_PLAY_BINGO_BUTTON = 'SET_IS_SHOW_PLAY_BINGO_BUTTON',
    SET_IS_SHOW_POPUP_ALREADY_USER = 'SET_IS_SHOW_POPUP_ALREADY_USER',
    SET_URL_REDIRECT_BACK_AFTER_DEPOSIT = 'SET_URL_REDIRECT_BACK_AFTER_DEPOSIT'
}
